import { render, staticRenderFns } from "./StandappLoginV2Component.vue?vue&type=template&id=270b28d3&"
import script from "./StandappLoginV2Component.vue?vue&type=script&lang=js&"
export * from "./StandappLoginV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports